import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';
import { message } from 'antd';

export const getSearchFilters = createAsyncThunk(
  'orderGroups/getSearchFilters',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/getSearchFilters?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const getOrders = createAsyncThunk(
  'orderGroups/getOrders',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/search?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          ordersGroups: response.data.data.ordersGroups,
          pagination: response.data.data.pagination,
        }
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const getOrderDetail = createAsyncThunk(
  'orderGroups/getOrderDetail',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/getOrderGroupData?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const refundOrder = createAsyncThunk(
  'orderGroups/refundOrder',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/refundPartial?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const getBankData = createAsyncThunk(
  'orderGroups/getBankData',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/getBankData?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const checkPayments = createAsyncThunk(
  'orderGroups/checkPayments',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/checkPayments?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const checkPaymentByExternalId = createAsyncThunk(
  'orderGroups/checkPaymentByExternalId',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/getPaymentStatus?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return response.data.message || 'Failed to fetch data';
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const cancelPayment = createAsyncThunk(
  'orderGroups/cancelPayment',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/cancelPayment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        message.error(response.data.message || 'Произошла ошибка при отмене платежа');
        return response.data.message || 'Failed to fetch data';
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const cancelOrder = createAsyncThunk(
  'orderGroups/cancelOrder',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/cancel?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const updateOrderComment = createAsyncThunk(
  'orderGroups/updateOrderComment',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/updateOrderComment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return {
          orderId: data.orderId,
          newComment: data.newComment,
          responseData: response.data.data
        };
      } else {
        return rejectWithValue('Failed to update order comment');
      }
    } catch (error) {
      console.error('Ошибка при обновлении комментария заказа:', error);
      return rejectWithValue(error);
    }
  }
);

export const confirmPayment = createAsyncThunk(
  'orderGroups/confirmPayment',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/confirmPayment?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to update order comment');
      }
    } catch (error) {
      console.error('Ошибка при обновлении комментария заказа:', error);
      return rejectWithValue(error);
    }
  }
);

export const awardCashback = createAsyncThunk(
  'orderGroups/awardCashback',
  async (data, { rejectWithValue }) => {
    const api = '/orderGroups/awardCashback?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to award cashback');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const generatePaymentCheck = createAsyncThunk(
  'orderGroups/generatePaymentCheck',
  async (data, { rejectWithValue }) => {
    const api = '/receipts/create?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to award cashback');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

export const generateRefundCheck = createAsyncThunk(
  'orderGroups/generateRefundCheck',
  async (data, { rejectWithValue }) => {
    const api = '/receipts/createRefund?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to award cashback');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error);
    }
  }
);

const initialState = {
    getSearchFiltersStatus: null,
    getOrdersStatus: null,
    getOrderDetailStatus: null,
    refundOrderStatus: null,
    getBankDataStatus: null,
    checkPaymentsStatus: null,
    checkPaymentByExternalIdStatus: null,
    cancelPaymentStatus: null,
    cancelOrderStatus: null,
    updateOrderCommentStatus: null,

    searchFilters: null,

    orders: [],
    totalOrders: 0,
    currentOrdersPage: 1,

    orderDetail: null,

    isProductsReturnModalOpen: false,
    isLogsModalOpen: false,

    bankData: null,

	  selectedGroupOrder: null,
    selectedOrder: null,
};

const orderGroupsSlice = createSlice({
  name: 'orderGroups',
  initialState,
  extraReducers: (builder) => {
    builder
      // getSearchFilters
      .addCase(getSearchFilters.pending, (state) => { state.getSearchFiltersStatus = 'pending'; })
      .addCase(getSearchFilters.fulfilled, (state, action) => {
        state.getSearchFiltersStatus = 'fulfilled';
        state.searchFilters = action.payload;
      })
      .addCase(getSearchFilters.rejected, (state) => { state.getSearchFiltersStatus = 'rejected'; })

      // getOrders
      .addCase(getOrders.pending, (state) => { state.getOrdersStatus = 'pending'; })
      .addCase(getOrders.fulfilled, (state, action) => {
        const data = action.payload;
        state.getOrdersStatus = 'fulfilled';
        state.orders = data?.ordersGroups;
        state.totalOrders = data?.pagination?.total;
      })
      .addCase(getOrders.rejected, (state) => { state.getOrdersStatus = 'rejected'; })

      // getOrderDetail
      .addCase(getOrderDetail.pending, (state) => { state.getOrderDetailStatus = 'pending'; })
      .addCase(getOrderDetail.fulfilled, (state, action) => { state.getOrderDetailStatus = 'fulfilled'; state.orderDetail = action.payload; })
      .addCase(getOrderDetail.rejected, (state) => { state.getOrderDetailStatus = 'rejected'; })

      // refundOrder
      .addCase(refundOrder.pending, (state) => { state.refundOrderStatus = 'pending'; })
      .addCase(refundOrder.fulfilled, (state, action) => {
        state.refundOrderStatus = 'fulfilled';
      })
      .addCase(refundOrder.rejected, (state) => { state.refundOrderStatus = 'rejected'; })

      // getBankData
      .addCase(getBankData.pending, (state) => { state.getBankDataStatus = 'pending'; })
      .addCase(getBankData.fulfilled, (state, action) => {
        state.getBankDataStatus = 'fulfilled';
        state.bankData = action.payload;
      })
      .addCase(getBankData.rejected, (state) => { state.getBankDataStatus = 'rejected'; })

      // checkPayments
      .addCase(checkPayments.pending, (state) => { state.checkPaymentsStatus = 'pending'; })
      .addCase(checkPayments.fulfilled, (state, action) => {
        state.checkPaymentsStatus = 'fulfilled';
      })
      .addCase(checkPayments.rejected, (state) => { state.checkPaymentsStatus = 'rejected'; })
      
      // checkPaymentByExternalId
      .addCase(checkPaymentByExternalId.pending, (state) => { state.checkPaymentByExternalIdStatus = 'pending'; })
      .addCase(checkPaymentByExternalId.fulfilled, (state, action) => {
        state.checkPaymentByExternalIdStatus = 'fulfilled';
      })
      .addCase(checkPaymentByExternalId.rejected, (state) => { state.checkPaymentByExternalIdStatus = 'rejected'; })

      // cancelPayment
      .addCase(cancelPayment.pending, (state) => { state.cancelPaymentStatus = 'pending'; })
      .addCase(cancelPayment.fulfilled, (state, action) => {
        state.cancelPaymentStatus = 'fulfilled';
      })
      .addCase(cancelPayment.rejected, (state) => { state.cancelPaymentStatus = 'rejected'; })

      // cancelOrder
      .addCase(cancelOrder.pending, (state) => { state.cancelOrderStatus = 'pending'; })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.cancelOrderStatus = 'fulfilled';
      })
      .addCase(cancelOrder.rejected, (state) => { state.cancelOrderStatus = 'rejected'; })

      // updateOrderComment
      .addCase(updateOrderComment.pending, (state) => { state.updateOrderCommentStatus = 'pending'; })
      .addCase(updateOrderComment.fulfilled, (state, action) => {
        state.updateOrderCommentStatus = 'fulfilled';
        // Обновляем комментарий в конкретном заказе
        const { orderId, newComment } = action.payload;
        state.orders.forEach(orderGroup => {
          orderGroup.orders?.forEach(order => {
            if (order.id === orderId) {
              order.comment = newComment;
            }
          });
        });
      })
      .addCase(updateOrderComment.rejected, (state) => { state.updateOrderCommentStatus = 'rejected'; })

      // PURGE
      .addCase(PURGE, () => { return initialState; })
  },
  reducers: {
    setCurrentOrdersPage: (state, action) => { state.currentOrdersPage = action.payload; },
    setIsProductsReturnModalOpen: (state, action) => { state.isProductsReturnModalOpen = action.payload; },
    setIsLogsModalOpen: (state, action) => { state.isLogsModalOpen = action.payload; },
    setSelectedGroupOrder: (state, action) => { state.selectedGroupOrder = action.payload; },
    setSelectedOrder: (state, action) => { state.selectedOrder = action.payload; },
    clearBankData: (state) => { 
      state.bankData = null; 
      state.getBankDataStatus = null; 
    },
  },
});

export const {
    setCurrentOrdersPage,
    setIsProductsReturnModalOpen,
    setIsLogsModalOpen,
    setSelectedGroupOrder,
    setSelectedOrder,
    clearBankData,
} = orderGroupsSlice.actions;

export default orderGroupsSlice.reducer;
